(function(){
  if (window.VarenfordCartDrawerExtras) return;
  window.VarenfordCartDrawerExtras = true;

  var protectionHandle = 'shipping-protection';
  var inFlight = false;
  var autoProtecting = false;
  var titleCache = {};
  var protectionOptOutKey = 'vfShippingProtectionOptOut';

  function money(cents){
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function cartUrl(path){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchCart(){
    return fetch(cartUrl('/cart.js'), {credentials:'same-origin', headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }

  function protectionLine(cart){
    return (cart.items || []).find(function(item){ return item.handle === protectionHandle; });
  }

  function nonProtectionCount(cart){
    return (cart.items || []).reduce(function(n,item){ return item.handle === protectionHandle ? n : n + item.quantity; }, 0);
  }

  function addVariant(variantId){
    return fetch(cartUrl('/cart/add.js'), {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:Number(variantId), quantity:1})
    }).then(function(r){return r.json();});
  }

  function changeLine(key, qty){
    return fetch(cartUrl('/cart/change.js'), {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();});
  }

  function protectionOptedOut(){
    try { return window.sessionStorage && sessionStorage.getItem(protectionOptOutKey) === '1'; }
    catch(e) { return false; }
  }

  function setProtectionOptedOut(value){
    try {
      if (!window.sessionStorage) return;
      if (value) sessionStorage.setItem(protectionOptOutKey, '1');
      else sessionStorage.removeItem(protectionOptOutKey);
    } catch(e) {}
  }

  function cleanMetaTitle(title, fallback){
    var out = String(title || fallback || '').replace(/\s*[|–—-]\s*Varenford\s*$/i, '').trim();
    return out || fallback || '';
  }

  function normalizePath(path){
    try { return new URL(path, window.location.origin).pathname; } catch(e) { return path || ''; }
  }

  function rememberMetaTitle(path, title, fallback){
    var value = cleanMetaTitle(title, fallback);
    var key = normalizePath(path);
    if (key && value) titleCache[key] = value;
    if (path && value) titleCache[path] = value;
    return value;
  }

  function primeCurrentProductTitle(){
    if (window.location.pathname.indexOf('/products/') !== -1) {
      rememberMetaTitle(window.location.pathname, document.title, '');
    }
  }

  function fetchMetaTitle(path, fallback){
    if (!path) return Promise.resolve(cleanMetaTitle(fallback, fallback));
    var key = normalizePath(path);
    if (titleCache[path]) return Promise.resolve(titleCache[path]);
    if (titleCache[key]) return Promise.resolve(titleCache[key]);
    return fetch(path, {credentials:'same-origin', headers:{'Accept':'text/html'}})
      .then(function(r){ if (!r.ok) throw new Error('title fetch failed'); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var title = doc.querySelector('title');
        return rememberMetaTitle(path, title && title.textContent, fallback);
      })
      .catch(function(){ return cleanMetaTitle(fallback, fallback); });
  }

  function hideProtectionLineInDrawer(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cart__item').forEach(function(item){
      var link = item.querySelector('a[href*="/products/' + protectionHandle + '"]');
      var name = item.querySelector('.cart__item-name');
      var isProtection = !!link || (name && /shipping protection/i.test(name.textContent || ''));
      item.classList.toggle('vf-cart-hidden-protection', isProtection);
      if (isProtection) item.setAttribute('aria-hidden', 'true');
    });
  }

  function updateDrawerItemTitles(){
    // Product titles in the cart drawer should stay as Shopify product.title.
    // Do not replace them with SEO/meta titles fetched from product pages.
    return;
  }

  function observeCartDrawer(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.vfProtectionObserver === '1' || !window.MutationObserver) return;
    drawer.dataset.vfProtectionObserver = '1';
    new MutationObserver(function(){
      hideProtectionLineInDrawer();
      updateDrawerItemTitles();
    }).observe(drawer, {childList:true, subtree:true});
  }

  function maybeAutoEnableProtection(root, cart){
    if (!root || root.getAttribute('data-vf-cart-extras') !== 'protection') return false;
    if (autoProtecting || inFlight || protectionOptedOut()) return false;
    if (nonProtectionCount(cart) <= 0) { setProtectionOptedOut(false); return false; }
    if (protectionLine(cart)) return false;
    var variantId = root.dataset.protectionVariantId;
    if (!variantId) return false;
    autoProtecting = true;
    addVariant(variantId).then(fetchCart).then(function(nextCart){
      applyProtectionCartUpdate(nextCart);
      setTimeout(updateAll, 350);
    }).finally(function(){ autoProtecting = false; });
    return true;
  }

  function updateProtection(root, cart){
    var box = root.querySelector('[data-vf-cart-protection]');
    var btn = root.querySelector('[data-vf-protection-toggle]');
    if (!box || !btn) return;
    var hasNormalItems = nonProtectionCount(cart) > 0;
    var line = protectionLine(cart);
    box.hidden = !hasNormalItems;
    box.classList.toggle('is-on', !!line);
    btn.setAttribute('aria-pressed', line ? 'true' : 'false');
    btn.setAttribute('aria-label', line ? 'Remove Shipping Protection' : 'Add Shipping Protection');
    btn.dataset.lineKey = line ? line.key : '';
  }

  function applyProtectionCartUpdate(cart){
    hideProtectionLineInDrawer();
    updateDrawerItemTitles();
    document.querySelectorAll('[data-subtotal]').forEach(function(el){
      el.textContent = money(cart && cart.total_price);
    });
    document.querySelectorAll('[data-vf-cart-extras="protection"]').forEach(function(root){
      updateProtection(root, cart || {items:[]});
    });
  }

  function updateAll(){
    observeCartDrawer();
    hideProtectionLineInDrawer();
    updateDrawerItemTitles();
    var roots = document.querySelectorAll('[data-vf-cart-extras]');
    if (!roots.length) return;
    fetchCart().then(function(cart){
      hideProtectionLineInDrawer();
      updateDrawerItemTitles();
      if (nonProtectionCount(cart) <= 0) setProtectionOptedOut(false);
      roots.forEach(function(root){
        if (maybeAutoEnableProtection(root, cart)) return;
        updateProtection(root, cart);
      });
    });
  }

  document.addEventListener('click', function(evt){
    var toggle = evt.target.closest('[data-vf-protection-toggle]');
    if (!toggle) return;
    evt.preventDefault();
    if (inFlight) return;
    inFlight = true;
    var root = evt.target.closest('[data-vf-cart-extras]');
    toggle.disabled = true;
    var lineKey = toggle.dataset.lineKey;
    var variantId = root && root.dataset.protectionVariantId;
    var box = root && root.querySelector('[data-vf-cart-protection]');
    if (box) box.classList.toggle('is-on', !lineKey);
    setProtectionOptedOut(!!lineKey);
    var action = lineKey ? changeLine(lineKey, 0) : addVariant(variantId).then(fetchCart);
    action.then(function(cart){
        applyProtectionCartUpdate(cart);
        setTimeout(function(){ applyProtectionCartUpdate(cart); }, 120);
      })
      .catch(function(){ window.location.reload(); })
      .finally(function(){ inFlight = false; toggle.disabled = false; });
  });

  document.addEventListener('page:loaded', updateAll);
  document.addEventListener('ajaxProduct:added', function(){ setTimeout(updateAll, 350); });
  document.addEventListener('cart:updated', function(){ setTimeout(updateAll, 350); });
  document.addEventListener('cart:build', function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); setTimeout(function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); }, 100); setTimeout(function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); }, 450); });
  primeCurrentProductTitle();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ primeCurrentProductTitle(); updateAll(); }); else updateAll();
})();
